import { useMemo } from 'react';
import styles from './style.module.scss';
import { List, Divider, Row, Col, Spin } from 'antd';
import { Button, PageHeader } from 'components';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useCoupons from '../useCoupons';
import { getCouponViewSections } from '../couponViewSections';

const ViewSection = ({ title, fields }) => (
  <List
    header={<div>{title}</div>}
    style={{ marginTop: 24 }}
    dataSource={fields}
    renderItem={(item) => (
      <List.Item>
        <b className={styles.itemName}>{item.text}</b>
        {item.value}
      </List.Item>
    )}
  />
);

const SingleCoupon = () => {
  const { t } = useTranslation();
  const { singleItem, loading } = useCoupons(false);

  const sections = useMemo(
    () => getCouponViewSections(t, singleItem),
    [t, singleItem],
  );

  const pageTitle = singleItem?.title_it || singleItem?.title || t('COUPON');

  return (
    <div>
      <PageHeader title={pageTitle} />
      <div className={styles.content}>
        <Spin spinning={loading}>
          {sections.map((section) => (
            <ViewSection
              key={section.title}
              title={section.title}
              fields={section.fields}
            />
          ))}
        </Spin>
        <Divider />
        <Row gutter={16}>
          {(singleItem?.can_update || singleItem?.can_approve) && (
            <Col>
              <Button>
                <Link to={`/promo/coupons/${singleItem?.id}/edit`}>
                  {t('MODIFICA')}
                </Link>
              </Button>
            </Col>
          )}
          <Col>
            <Button type={'secondary'}>
              <Link to={'/promo/coupons'}>{t('TORNA INDIETRO')}</Link>
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SingleCoupon;
